import { SagaIterator } from 'redux-saga';
import { call } from 'redux-saga/effects';
import { GlobalActions, GlobalPut, ModalType } from '@ps20-frontend/shop-integration-redux';
import { IAppState } from '../../appState';
import { selectIsShopPricingStale } from '../../selectors/transient-state.selector';

export function* refuseWhileShopPricingIsStale(state: IAppState): SagaIterator<boolean> {
  if (!selectIsShopPricingStale(state)) {
    return false;
  }
  yield call(
    GlobalPut.getInstance().put,
    new GlobalActions().requestModal(ModalType.AUSGEWAEHLTES_PRODUKT_NICHT_TARIFIERT_ERROR),
  );
  return true;
}
